import { render, staticRenderFns } from "./ApproveRejectPersonKpi.vue?vue&type=template&id=d2f41a04"
import script from "./ApproveRejectPersonKpi.vue?vue&type=script&lang=js"
export * from "./ApproveRejectPersonKpi.vue?vue&type=script&lang=js"
import style0 from "./ApproveRejectPersonKpi.vue?vue&type=style&index=0&id=d2f41a04&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports